import {axiosInstance} from "@/plugins/axios";

export async function getUsers() {
  const response = await axiosInstance.get(`users`);
  return response.data;
}
